import { gql } from 'src/utils/gql/query';

export const updateUserNoteGqlMutation = gql`
  mutation ($id: ID!, $data: update_notes_input!) {
    update_notes_item(id: $id, data: $data) {
      id
      date_created
      content
    }
  }
`;
